import { Colours } from '@ecdlink/ui';

export const attendanceColor: Colours = 'errorMain';
